import React, { Component } from 'react'
import RenderInBrowser from 'react-render-in-browser';
import Slide from '@mui/material/Slide'
import Question from './Question.js'
import { Button, Card, Grid, Typography, Box, CircularProgress } from '@mui/material';
import Clustered from './Clustered.js'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import "react-sweet-progress/lib/style.css";

const styles = theme => ({
    root: {
        textAlign:'center'
    },
    label: {
        display:'table-cell',
        verticalAlign: 'middle',
        position:"absolute"
    },
    ielabel: {
        display:'table-cell',
        verticalAlign: 'middle'
    },
    button: {
        display:'table',
        minHeight:'345px',
        width:'100%'
    },
    buttonPrevious: {
        [theme.breakpoints.down('xs')]: {
            position: "absolute",
            left: '0px',
        }
    },
    buttonNext: {
        [theme.breakpoints.down('xs')]: {
            position: "absolute",
            right: '-20px',
        }
    }
})

function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

class Quiz extends Component {
    constructor(props){
        super(props);
        this.state = {
          CurrentQuestion: [],
          Questions: [],
          CurrentQuestionsIndex: 0,
          PreviousQuestionIndex: -1,
          QuestionCount: 0,
          CurrentQuestionNotAnswered: true,
          direction: 'left',
          QuestionsAnswered: 0,
          CurrentRequiredQuestion: 0,
          FirstQuestionIndex:0,
          AllVisibleQuestionsAnswered: false,
          Saving: false,
          NextQuestionIndex: -1,
          CompletingHRA: {
            IsCompleting: false,  
            Error: '',
            ErrorMessage: '',
            ErrorBody: []

          }
        }

    }

    componentDidUpdate(){
        if(this.state.Questions.length==0 && this.state.CurrentQuestion.length==0){
        let questions = this.props.questions.SurveyData[0]
        //let questions = testQuiz.SurveyData[0];
        let questioncount = 0
        let visiblequestioncount = 0
        let lastquestionindex = 0
        let firstquestion = -1
        let firstquestioninassessment = -1
        let hasVisibleQuestionSetQuestions = false
        
        //find the last visible question in the array and count the amount of total visible questions
        //for question sets, find any visible questions, and any unanswered questions in the set
        while(questioncount < questions.QuestionSetQuestionSet.length){
            if(questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions.length > 1){
                hasVisibleQuestionSetQuestions = false
                for(let x=0; x< questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions.length; x++){
                    if(questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions[x].QuestionDisplayedFlag=="1"){
                        hasVisibleQuestionSetQuestions = true
                        if(firstquestion<0  && !questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions[x].Responses[0].Response.length){
                            firstquestion = questioncount
                        }
                    }
                }
                if(hasVisibleQuestionSetQuestions) {
                    visiblequestioncount++;
                    lastquestionindex = questioncount}

            } else {
                if (questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions[0].QuestionDisplayedFlag=="1"){
                    visiblequestioncount++
                    lastquestionindex = questioncount
                    if(firstquestioninassessment < 0){
                        firstquestioninassessment = questioncount
                    }
                    if(firstquestion<0 
                        && !questions.QuestionSetQuestionSet[questioncount].QuestionSetQuestions[0].Responses[0].Response.length)
                        {firstquestion = questioncount}
                }
            }
            questioncount++
        }
        //if everything is answered, go to the end? 
        if(firstquestion < 0){
            firstquestion = firstquestion <= -1 ? lastquestionindex : firstquestion
            this.props.setCurrentIndex(questions.QuestionSetQuestionSet.length)
        } else {

            this.props.setCurrentIndex(firstquestion)
        }

        if(this.props.startfromBeginning){
            this.setState({
            Questions: questions.QuestionSetQuestionSet,
            CurrentQuestion: questions.QuestionSetQuestionSet[firstquestion],
            QuestionCount: questions.QuestionSetQuestionSet.length,
            CurrentRequiredQuestion: firstquestion,
            CurrentQuestionsIndex: firstquestion,
            FirstQuestionIndex: firstquestioninassessment
            })
            this.props.updateQuestionTotal(visiblequestioncount)
        } else {

            this.setState({
                Questions: questions.QuestionSetQuestionSet,
                CurrentQuestion: questions.QuestionSetQuestionSet[lastquestionindex],
                QuestionCount: visiblequestioncount,
                CurrentRequiredQuestion: visiblequestioncount-1,
                CurrentQuestionsIndex: lastquestionindex,
                QuestionsAnswered: visiblequestioncount
                })
        }}
        //console.log("quiz state", this.state)
        
    }

    findNextQuestionIndex = () => {
        var notFound = true
        var index = this.state.CurrentQuestionsIndex
        while(notFound && index < this.state.Questions.length-1){
            //let index = this.state.CurrentQuestionsIndex == this.state.Questions.length-1 ? this.state.CurrentQuestionsIndex : this.state.CurrentQuestionsIndex+1;
                if(this.state.Questions[index+1] && this.state.Questions[index+1].QuestionSetQuestions.length > 1){
                    //if group, find ANY displayed questions 
                    //console.log('group question')
                    for(let x=0; x<this.state.Questions[index+1].QuestionSetQuestions.length; x++){
                       // console.log('question name: ' + this.state.Questions[index+1].QuestionSetQuestions[x].QuestionName + " is displayed ? " + this.state.Questions[index+1].QuestionSetQuestions[x].QuestionDisplayedFlag)
                        if(this.state.Questions[index+1].QuestionSetQuestions[x].QuestionDisplayedFlag == 1){
                            
                            notFound = false
                            break
                        }
                    }
                    index++;
                } else {
                    if(this.state.Questions[index+1].QuestionSetQuestions[0].QuestionDisplayedFlag == 1){
                        index++;
                        notFound = false
                    }else{
                        index++
                    } 
                }
                
        } 

        return notFound ? -1 : index
    }

    nextQuestion = () => {
        let indexOfNextQuestion = this.findNextQuestionIndex();
        if(indexOfNextQuestion === -1){
            //found the end of the assessment
            this.completeAssessment();
        } else {
            this.props.setCurrentIndex(indexOfNextQuestion)
            this.setState({
                direction: 'left',
                CurrentQuestion: this.state.Questions[indexOfNextQuestion],
                PreviousQuestionIndex: this.state.CurrentQuestionsIndex,
                CurrentQuestionsIndex: indexOfNextQuestion,
                CurrentQuestionNotAnswered: true,
                CurrentRequiredQuestion: this.state.CurrentRequiredQuestion+1
            })
        }
        
        
    }

    previousQuestion = () => {
        var notFound = true
        var index = this.state.CurrentQuestionsIndex
        while(notFound){
            //let index = this.state.CurrentQuestionsIndex == this.state.Questions.length-1 ? this.state.CurrentQuestionsIndex : this.state.CurrentQuestionsIndex+1;
            if(this.state.Questions[index-1].QuestionSetQuestions[0].QuestionDisplayedFlag == 1){
                index--;
                notFound = false
            } else{
                index--
            }
        }
        this.setState({
            direction: 'right',
            CurrentQuestion: this.state.Questions[index],
            PreviousQuestionIndex: this.state.CurrentQuestionsIndex,
            CurrentQuestionsIndex: index,
            CurrentQuestionNotAnswered: true,
            CurrentRequiredQuestion: this.state.CurrentRequiredQuestion-1
        })
    }

    

    updateResponseValue = (value) => {
        console.log('saving')
        if(!this.state.Saving){
        this.setState({Saving: true})
        fetch('../../WsWebServiceHra/SaveAnswer/' + 
            this.props.authtoken + '/' +
            this.props.responseguid + '/' +
            this.state.CurrentQuestion.QuestionSetQuestions[0].QuestionId + '/' +
            value.toString() + '/',
        {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        }) 
        .then(response=>response.json())
        .then(response => {
            if(response.Success){
                //some branching logic BS goes in here too, I guess, eventually
                //please don't make me do it
                //please
                //OH WE DOIN IT BOYS
                let questions = this.state.Questions;
                if(response.Info[0] && response.Info[0].Changes){
                    let change
                    for(var x=0; x<response.Info[0].Changes.length; x++){
                        change=response.Info[0].Changes[x]
                        this.branchingLogic(questions,change)
                    }
                }
                //if question was previously unanswered
                if (!questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Responses[0].Response.length){
                    this.props.updateQuestionsAnswered(this.state.QuestionsAnswered+1, this.state.CurrentQuestionsIndex)
                    this.setState({
                        QuestionsAnswered: this.state.QuestionsAnswered+1
                    })
                    
                }
                questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Responses[0].Response = value;
                this.setState({
                    direction: 'right',
                    Questions: questions,
                    CurrentQuestionNotAnswered: false
                }, () => {
                    this.moveToNext()
                    this.setState({
                      Saving:false
                    })
                })
                
            }
            
        })
      }
        
    }

    questionSetUpdateResponseValue = (questionID, value) => {
        //since saving has to be done at a higher level for QSs, 
        //this version of UpdateResponseValue does all the other stuff.
        //This is called once the QS is marked as complete
        //QS is marked as complete when

        //def: value - the answer being saved
        //def: questionID - the index of the question in the questionSet
        
          fetch('../../WsWebServiceHra/SaveAnswer/' + 
            this.props.authtoken + '/' +
            this.props.responseguid + '/' +
            questionID + '/' +
            value.toString() + '/',
        {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {
            }
        })
        .then(response=>response.json())
        .then(response => {
            if(response.Success){
                //some branching logic BS goes in here too, I guess, eventually
                //please don't make me do it
                //please
                //OH WE DOIN IT BOYS
                let questions = this.state.Questions;
                if(response.Info[0] && response.Info[0].Changes){
                    let change
                    for(var x=0; x<response.Info[0].Changes.length; x++){
                        change=response.Info[0].Changes[x]
                        questions = this.branchingLogic(questions,change)
                    }
                }
                //if question was previously unanswered
                //count the questions answered in the question set, if it equals length -> question done
                //Required questions answered
                var prevAnswer;

                var requiredQuestions = 0;
                var answeredQuestions = 0;
                var thisquestion;

                for(var x=0; x<questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions.length; x++){
                    
                    thisquestion = questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x]
                  
                    if(thisquestion.QuestionId == questionID){
                        prevAnswer = questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x].Responses[0].Response
                        questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x].Responses[0].Response = value;

                    }
                    if(thisquestion.QuestionDisplayedFlag == "1"){
                        requiredQuestions++;
                    }
                    if(thisquestion.Responses[0].Response != "" && thisquestion.Responses[0].Response != "-1"){
                        answeredQuestions++;
                    }
                }
                //NOTE: only zoom forward after next is select, where applicable
                //don't zoom forward for slider questions
                //checkbox is fine
                if(requiredQuestions <= answeredQuestions){
                    if(thisquestion.QuestionTypeKeyName != "SLIDER"){
                      if(prevAnswer != value && prevAnswer == ""){
                        this.props.updateQuestionsAnswered(this.state.QuestionsAnswered+1)
                        this.setState({
                            QuestionsAnswered: this.state.QuestionsAnswered+1
                        })
                       }
                    
                      this.setState({
                        direction: 'right',
                        Questions: questions,
                        CurrentQuestionNotAnswered: false
                      }, () => {
                          //if(thisquestion.QuestionTypeKeyName != "SLIDER"){
                            this.moveToNext();
                         // }
                      })
                    }
                    
                }
                
            }
            
        })
        
          
        

    }

    branchingLogic = (questions, change) => {
        for(var y=this.state.CurrentQuestionsIndex; y<questions.length; y++){
            for(var x=0; x<questions[y].QuestionSetQuestions.length; x++){
                if(change.QuestionId == questions[y].QuestionSetQuestions[x].QuestionId){
                    var originalDisplay = questions[y].QuestionSetQuestions[x].QuestionDisplayedFlag;
                    questions[y].QuestionSetQuestions[x].QuestionDisplayedFlag=change.DisplayFlag
                    questions[y].QuestionSetQuestions[x].QuestionRequiredFlag=change.RequiredFlag

                    //If we turn a question off, we only want to change the count of the cards
                    //Gotta check if the whole set is off or not if it's grouped
                    let questionCount = this.state.QuestionCount
                    if(change.DisplayFlag == "1" && change.DisplayFlag != originalDisplay && questions[y].QuestionSetQuestions.length<=1){
                        this.setState({
                            QuestionCount: this.state.QuestionCount+1
                        })
                        this.props.updateQuestionTotal(questionCount+1)
                    } 
                    if (change.DisplayFlag == "0" && change.DisplayFlag != originalDisplay && questions[y].QuestionSetQuestions.length<=1){
                        this.setState({
                            QuestionCount: this.state.QuestionCount-1
                        })
                        this.props.updateQuestionTotal(questionCount-1)
                    }
                }
            }
            
        }
        this.setState({
          Questions:questions
        })
        return questions
    }

    findNextVisibleQuestion = () => {
        
    }

    moveToNext = () => {
        
        if(this.state.QuestionsAnswered==this.state.QuestionCount){
            this.completeAssessment()
        } else {
            setTimeout(() => {
                this.nextQuestion()
            }, 200)
            
        }
    }

    findMissingQuestion = () => {

    }

    completeAssessment = () => {
        //complete the mini assessment
        this.props.setCurrentIndex(this.state.Questions.length)
        this.setState(prevState => ({
            CompletingHRA: {
                ...prevState.CompletingHRA, IsCompleting: true
            }
        }))
        fetch('../../WsWebServiceHra/CompleteAssessment/' + this.props.authtoken + '/' + this.props.responseguid + '/', 
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: {

            }
        })
        .then(response=>response.json())
        .then(response=>{
            if(response.Success && !response.Info.length){
                console.log('hra completed')
                //this.props.completeSuccessful(true)
                //console.log(this.state.CompletingHRA)
            } else {
                //console.log('hra not completed', response)
                if(response.Info.length){

                }
                this.setState(prevState => ({
                    CompletingHRA: {
                        ...prevState.CompletingHRA, IsCompleting: true
                    }
                }))
            }
        })
    }

    wrappernextQuestion = () => {
        if (this.state.CurrentQuestionsIndex == this.state.Questions.length-1){
            this.completeAssessment()
        } else {
          if(!this.state.Saving){
            this.setState({
            direction: 'right',
            CurrentQuestionNotAnswered: false
            })
            setTimeout(() => {
                this.nextQuestion()
            }, 200)
          }
        }
        
    }

    wrappernextQuestionForGroup = () => {
      if (this.state.CurrentQuestionsIndex == this.state.Questions.length-1){
          this.completeAssessment()
      } else {
          this.setState({
          direction: 'right',
          CurrentQuestionNotAnswered: false
          })
          setTimeout(() => {
              this.nextQuestion()
          }, 200)
        }
      
  }

    wrapperpreviousQuestion = () => {
        this.setState({
            direction: 'left',
            CurrentQuestionNotAnswered: false
        })
        setTimeout(() => {
            this.previousQuestion()
        }, 200)
    }

    async saveRemaining(){
        var currentQuestion
        if(this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].QuestionTypeKeyName == "CHECKBOX"){
          var no = this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Answers[0].AnswerName == "No" ? this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Answers[0].AnswerId : this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Answers[1].AnswerId
          for(var x=0; x<this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions.length; x++){
            currentQuestion = this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x];
            if(currentQuestion.Responses[0].Response == ""){
                this.questionSetUpdateResponseValue(currentQuestion.QuestionId, no)
            }
          }
        }
        if(this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].QuestionTypeKeyName == "SLIDER"){
          var answer = this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[0].Answers[0].AnswerId
          var numberSaved = 0
          var questions = this.state.Questions
          for(var x=0; x<questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions.length; x++){
            currentQuestion = questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x];
            if(currentQuestion.Responses[0].Response == ""){
                this.questionSetUpdateResponseValue(currentQuestion.QuestionId, answer)
                numberSaved++
                questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions[x].Responses[0].Response = answer;
            }
            
          }

          //added an isSaved flag to the Slider QuestionSet 
          //allows it to be incremented once in the loading bar
          if(!questions[this.state.CurrentQuestionsIndex].isSaved){
            questions[this.state.CurrentQuestionsIndex].isSaved = true;
            this.props.updateQuestionsAnswered(this.state.QuestionsAnswered+1)
            this.setState({
              Questions: questions, 
              QuestionsAnswered: this.state.QuestionsAnswered+1
            }, (
              this.wrappernextQuestionForGroup()
            ))
          } else {
            this.wrappernextQuestionForGroup()
          }

         // setTimeout(() => {

          if(numberSaved != 0){
            
          } else {
            
          }
          
          
          //}, numberSaved)
        }
        
    }

//<h2 className={classes.root}>Question {this.state.CurrentRequiredQuestion+1} out of {this.state.QuestionCount}</h2>

    render() {
        //<Grid item xs={12}>
        //<Progress status="active" percent={Math.floor((this.state.CurrentRequiredQuestion)/this.state.QuestionCount*100)} />
        //</Grid>
        const {classes} = this.props

        //Single question vs question set stuffffffff
        var question;
        if (this.state.Questions[this.state.CurrentQuestionsIndex] && this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetTypeKeyName == "STANDARD"){
            question = <Question 
                            className={classes.root} 
                            uom={this.props.uom} 
                            key={this.state.CurrentQuestion.QuestionSetId}
                            questionPrompts = {this.props.questionPrompts}
                            validationMessages = {this.props.validationMessages} 
                            question={this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetQuestions} updateResponseValue={this.updateResponseValue.bind(this)} />
        }
        if (this.state.Questions[this.state.CurrentQuestionsIndex] && this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetTypeKeyName == "CLUSTERED"){
            question = <Clustered className={classes.root} key={this.state.CurrentQuestion.QuestionSetId} question={this.state.Questions[this.state.CurrentQuestionsIndex]} nextQuestion={this.wrappernextQuestion.bind(this)} saveRemaining={this.saveRemaining.bind(this)} questionSetUpdateResponseValue={this.questionSetUpdateResponseValue.bind(this)} 
            validationMessages = {this.props.validationMessages} />
        }
        if (this.state.CompletingHRA.IsCompleting) {
            console.log('iscompleting')
            question = <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingTop: '60px'}}>
                <Typography variant="body1" gutterBottom={true} align={'center'} sx={{paddingBottom: '20px'}}> Calculating your score...</Typography>
                <CircularProgress />
                <Typography variant="body2" gutterBottom={true} align={'center'} sx={{paddingTop: '20px'}}>This may take several seconds</Typography>
            </Box>


        }
        
        //if (this.state.Questions[this.state.CurrentQuestionsIndex].QuestionSetTypeKeyName == "BIOMETRIC"){
        //    question = <Biometric className={classes.root} key={this.state.CurrentQuestion.QuestionSetId} question={this.state.Questions[this.state.CurrentQuestionsIndex]} updateResponseValue={this.questionSetUpdateResponseValue.bind(this)} />
        //}

        
        var isIphone = iOS()
       var iphoneStyleLeft = '0px'
       var iphoneStyleRight = '-20px'
       
       if(isIphone){
         iphoneStyleRight = '0px'
         iphoneStyleLeft = '-5%'
       }
        if(this.state.Questions.length && this.state.CurrentQuestion){

            let cardIsAnswered = this.state.CurrentQuestion.QuestionSetQuestions[0].Responses[0].Response.length
            if(this.state.CurrentQuestion.QuestionSetQuestions.length > 0){
                var currentSet = this.state.CurrentQuestion.QuestionSetQuestions
                let required = 0;
                let answered = 0;
                for(var x=0; x<currentSet.length; x++){
                    if(currentSet[x].QuestionRequiredFlag == "1"){
                        required++
                    }
                    if(currentSet[x].Responses[0].Response.length){
                        answered++
                    }
                }
                cardIsAnswered = answered >= required ? 1 : -1;
            }
            return (
            //map each question
            <Grid container spacing={1} xs={12} justify='center' alignItems="center">
                

                <Grid item sm={2} xs={0.5} style={{minHeight:'350px'}} >
                    <div className={classes.buttonPrevious} style={{left: iphoneStyleLeft}}>
                        <RenderInBrowser only chrome firefox safari mobile>
                            <Button onClick={this.wrapperpreviousQuestion} 
                            disabled={this.state.CurrentRequiredQuestion==this.state.FirstQuestionIndex}  
                            classes={{root:classes.button, label: classes.label}}><NavigateBeforeIcon /></Button>
                        </RenderInBrowser>
                        <RenderInBrowser except chrome firefox safari mobile>
                            <Button onClick={this.wrapperpreviousQuestion} 
                            disabled={this.state.CurrentRequiredQuestion==this.state.FirstQuestionIndex}  
                            classes={{root:classes.button, label: classes.ielabel}}><NavigateBeforeIcon /></Button>
                        </RenderInBrowser>
                        
                    </div>                
                </Grid>
                <Grid item md={8} sm={8} xs={11} style={{minHeight:'350px'}}>
                    
                    <Slide direction={this.state.direction} in={this.state.CurrentQuestionNotAnswered} mountOnEnter unmountOnExit>
                        {question}
                    </Slide>
                </Grid>
                <Grid item sm={2} xs={0.5} style={{minHeight:'350px'}} >
                    <div className={classes.buttonNext} style={{right: iphoneStyleRight}}>
                        <RenderInBrowser only chrome firefox safari mobile>
                            <Button onClick={this.wrappernextQuestion} 
                            disabled={cardIsAnswered<=0} 
                            classes={{root:classes.button, label: classes.label}}><NavigateNextIcon/></Button>
                        </RenderInBrowser>
                        <RenderInBrowser except chrome firefox safari mobile>
                            <Button onClick={this.wrappernextQuestion} 
                            disabled={cardIsAnswered<=0} 
                            classes={{root:classes.button, label: classes.ielabel}}><NavigateNextIcon/></Button>
                        </RenderInBrowser>
                        
                    </div>
                </Grid>
                <Grid container xs={12}>
                    <Button onClick={this.completeAssessment} variant='filled'>Complete Assessment</Button>
                </Grid>
             </Grid>
             
            )
        } else {
            return(
                <Card>EmptyCard</Card>
            )
        }
    }
}

function checkiPhone(){
  return true
}

export default Quiz;